export const getDefaultState = () => {
  return {
    OAPICart: {
      deviceOrderUuid: "",
      discounts: 0,
      fees: 0,
      feesDetail: [],
      items: [],
      subtotal: 0,
      taxTotal: 0,
      total: 0,
      promoCode: "",
      cartExpirationTime: 0,
      appliedDiscounts: []
    }
  };
};

// initial state
export const state = getDefaultState();

// getters
const getters = {
  getOAPItotalTaxes(state) {
    return state.OAPICart.taxTotal;
  },
  getOAPISubTotal(state) {
    return state.OAPICart.subtotal;
  },
  getOAPITotal(state) {
    return state.OAPICart.total;
  },
  getOAPICartItem(state) {
    return (id) => {
      if (state.OAPICart.items.length) {
        return state.OAPICart.items.find((item) => item.id === id);
      }
      return {};
    };
  },
  getOAPICart(state) {
    return state.OAPICart;
  },
  getOAPITotalFees(state) {
    return state.OAPICart.fees;
  },
  getOAPITotalDiscounts(state) {
    return state.OAPICart.discounts;
  },
  getOAPIFeesDetail(state) {
    return state.OAPICart.feesDetail;
  },
  getOAPICartDiscountsTags(state) {
    return state.OAPICart.appliedDiscounts.map((discount) => discount.tags).flat();
  }
};

// actions
const actions = {
  OAPICart({ commit }, data) {
    commit("setOAPIcart", data);
  },
  clearOAPICart({ commit }) {
    commit("resetOAPIState");
  }
};

// mutations
const mutations = {
  setOAPIcart(state, data) {
    state.OAPICart = { ...state.OAPICart, ...data };
  },
  resetOAPIState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
